import { c as _c } from "react/compiler-runtime";
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
export function RecommendedCreditScoreSummaryTableTitle(t0) {
  const $ = _c(2);
  const {
    hasAmexOffer
  } = t0;
  const creditOrCreditScoreLabel = hasAmexOffer ? "credit" : "credit score";
  let t1;
  if ($[0] !== creditOrCreditScoreLabel) {
    t1 = <><Mobile creditOrCreditScoreLabel={creditOrCreditScoreLabel} /><Desktop creditOrCreditScoreLabel={creditOrCreditScoreLabel} /></>;
    $[0] = creditOrCreditScoreLabel;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}